// src/components/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation(); // 현재 URL 경로를 가져옵니다.

  useEffect(() => {
    // pathname이 변경될 때마다 (즉, 페이지 이동이 발생할 때마다)
    // 스크롤을 맨 위(0,0)로 이동시킵니다.
    window.scrollTo(0, 0);
  }, [pathname]); // pathname이 의존성 배열에 있으므로, pathname이 바뀔 때마다 useEffect가 실행됩니다.

  return null; // 이 컴포넌트는 UI를 렌더링하지 않습니다.
}

export default ScrollToTop;
